import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_GOAL_COUNTER_EXPERIMENT = defineFcm('psf_share_goal_counter_experiment')
	.asJson(
		z.object({
			enabled: z.boolean().optional(),
			experimentName: z.string().optional(),
		}),
	)
	.withDefault({ enabled: false, experimentName: undefined })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'PSF share page (Super Recruiter flow)',
		description: `Gates the Share Goal Counter experiment, which replaces the recruit-goal slider on the PSF share page with a
			3-step share counter. The first run targets the en-US locale (the Super Recruiter flow): give the en-US locale row
			enabled and experimentName. A later run for other markets uses country rows with their own experimentName; a locale
			row always wins over a country row, so en-US users keep resolving to the en-US row. To switch a market off, edit its
			row to enabled: false rather than using Disable: a disabled en-US row drops out entirely and en-US users would fall
			through to their country row.`,
		supportedGroups: { locales: true, countries: true },
		template: { enabled: true, experimentName: 'psf_share_goal_counter_experiment' },
		deprecated: 'FCM no longer in use — safe to delete after 2026-11-02',
	});
